import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="py-20 relative overflow-hidden" data-id="element-54">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-jml-blue to-navy-dark z-0" data-id="element-55" />
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2070&auto=format&fit=crop')] opacity-10 mix-blend-overlay z-0" data-id="element-56" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-58">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-59">
            ¿Necesitas un equipo confiable para tu próximo proyecto?
          </h2>
          <p className="text-xl text-blue-100 mb-10 font-light max-w-2xl mx-auto" data-id="element-60">
            Trabajamos con empresas que requieren cumplimiento, seguridad y
            resultados.
          </p>
          <a href="https://wa.me/56921239377?text=Hola%2C%20me%20gustar%C3%ADa%20solicitar%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-jml-orange hover:bg-orange-600 text-white px-10 py-5 rounded-md font-bold text-lg transition-all shadow-xl shadow-black/20 hover:-translate-y-1" data-id="element-61">
            Contactar ahora
            <ArrowRight size={24} data-id="element-62" />
          </a>
        </motion.div>
      </div>
    </section>;
}